import { nextTick } from "vue"

/**
 * 评论内容展开/收起逻辑
 */
export function useCommentExpand() {
    const commentRefs = new Map()

    const setCommentRef = (el, item) => {
        if (el && item) {
            commentRefs.set(item.id, el)
            nextTick(() => {
                checkIfNeedExpand(item, el)
            })
        }
    }

    const checkIfNeedExpand = (item, el = null) => {
        if (!item || !item.comment || item.comment === "<p></p>") {
            item._needExpand = false
            return false
        }

        if (item.commentisExpanded) {
            item._needExpand = true
            return true
        }

        if (el) {
            const clone = el.cloneNode(true)
            clone.style.cssText = `
                position: absolute;
                visibility: hidden;
                width: ${el.offsetWidth}px;
                display: block;
                -webkit-line-clamp: none;
                overflow: visible;
                max-height: none;
            `
            document.body.appendChild(clone)
            const fullHeight = clone.scrollHeight
            document.body.removeChild(clone)

            const lineHeight = parseFloat(getComputedStyle(el).lineHeight) || 21
            const maxHeight = lineHeight * 5
            item._needExpand = fullHeight > maxHeight
            return item._needExpand
        }

        const tempDiv = document.createElement("div")
        tempDiv.className = "content mainp"
        tempDiv.style.cssText = `
            position: absolute;
            visibility: hidden;
            width: 400px;
            line-height: 1.5;
            font-size: 14px;
            word-wrap: break-word;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            overflow: hidden;
            padding: 0;
            margin: 0;
        `
        tempDiv.innerHTML = item.comment
        document.body.appendChild(tempDiv)
        const clampedHeight = tempDiv.clientHeight
        tempDiv.style.display = "block"
        tempDiv.style.webkitLineClamp = "none"
        tempDiv.style.overflow = "visible"
        const fullHeight = tempDiv.scrollHeight
        document.body.removeChild(tempDiv)
        item._needExpand = fullHeight > clampedHeight
        return item._needExpand
    }

    const needExpand = (item) => {
        if (!item || !item.comment || item.comment === "<p></p>") return false
        if (item.commentisExpanded) return true
        if (item._needExpand === undefined) {
            const el = commentRefs.get(item.id)
            checkIfNeedExpand(item, el)
        }
        return item._needExpand || false
    }

    const checkAllCommentsNeedExpand = (formData) => {
        if (!formData?.dimensions) return
        formData.dimensions.forEach((dimension) => {
            dimension.items?.forEach((item) => {
                if (item.comment && item.comment !== "<p></p>") {
                    const el = commentRefs.get(item.id)
                    checkIfNeedExpand(item, el)
                }
            })
        })
    }

    const commentisExpandedtoggleExpand = (item) => {
        item.commentisExpanded = !item.commentisExpanded
        nextTick(() => {
            const el = commentRefs.get(item.id)
            checkIfNeedExpand(item, el)
        })
    }

    return {
        commentRefs,
        setCommentRef,
        checkIfNeedExpand,
        needExpand,
        checkAllCommentsNeedExpand,
        commentisExpandedtoggleExpand
    }
}
